module.exports = __webpack_public_path__ + "img/symbol_6.74e0bc19.png";